(function () {
  angular.module('MktzapApp.Controllers')
    .controller('ChatbotController', chatbots);

  chatbots.$inject = ['$rootScope', 'FoundationApi', 'ChatbotService', 'NotificationService', 'ngTableParams', 'CompanyService'];

  function chatbots ($rootScope, FoundationApi, ChatbotService, NotificationService, ngTableParams, CompanyService) {
    var vm = this;
    vm.filters = {}
    vm.metadata = {}
    vm.chatbot = {}
    vm.chatbot.configs = {}
    vm.chatbotTable = new ngTableParams({
	        count: 50
	    }, {
	    	counts: [25, 50, 100],
	        getData: function ($defer, params) {
	        	var obj = params.url();
        var keys = Object.keys(vm.filters);
        for (var i = 0; i < keys.length; i++) {
          var filterValue = vm.filters[keys[i]];
          if (filterValue != null && filterValue !== '') {
            obj['filter[' + keys[i] + ']'] = filterValue;
          }
        }

	        	ChatbotService
	        	.paged(obj)
	        	.$promise
	        	.then(function (data) {
        			params.total(data.total);
            $defer.resolve(data.data);
            vm.data_total = data.total;
            vm.data_result = data.data.length;
          }).catch(function (data) {
            NotificationService.errorHandler(data, 'não foi possível listar os chatbots.');
          });
	        }
	    });
	    CompanyService.findForChannel({
      type: 'chatbot'
    }, function (data) {
      vm.company = data;

      if (!vm.chatbot) {
        vm.chatbot = {};
        vm.chatbot.company_id = vm.company.id;
      }
      if (vm.company.metadata !== undefined && vm.company.metadata !== null) {
        for (var i in vm.company.metadata) {
          if (typeof vm.company.metadata[i]['value'] === 'string') {
            vm.metadata[vm.company.metadata[i]['key']] = JSON.parse(vm.company.metadata[i]['value']);
          } else {
            vm.metadata[vm.company.metadata[i]['key']] = vm.company.metadata[i]['value'];
          }
        }
      }
    });
    // chatbots
    vm.addChatbot = function () {
      vm.chatbot = {

      };
      FoundationApi.publish('addChatbotModal', 'open');
    }

    vm.editChatbot = function (chatbot_id) {
      ChatbotService
        .findOne({ id: chatbot_id })
        .$promise
        .then(function (data) {
          vm.chatbot = data;
          if (vm.chatbot.channel_type.indexOf('WebChat') != -1) {
            vm.channel_type = 'webchat';
          }
          if (vm.chatbot.channel_type.indexOf('Facebook') != -1) {
            vm.channel_type = 'facebook';
          }
          if (vm.chatbot.channel_type.indexOf('Whatsapp') != -1) {
            vm.channel_type = 'whatsapp';
          }
          if (vm.chatbot.channel_type.indexOf('Waent') != -1) {
            vm.channel_type = 'waent';
          }
          FoundationApi.publish('addChatbotModal', 'open');
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao processar requisição, por favor tente novamente.');
        });
    }

    vm.deleteChatbot = function (chatbot, index) {
      FoundationApi.publish('confirmDeleteModal', 'close');

      ChatbotService.delete({
        id: vm.deleting.id
      }, function (data) {
        vm.chatbotTable.reload()
        NotificationService.successHandler(data, 'Os dados foram removidos com sucesso!');
      });
    }

    vm.saveChatbot = function (chatbot) {
      vm.checkConfig = false;
      vm.chatbot = chatbot
      vm.chatbot.channel_type = vm.channel_type
      vm.chatbot.configs = JSON.stringify(vm.chatbot.configs)
      if (vm.chatbot.id == undefined) {
        ChatbotService
          .create({}, chatbot)
          .$promise
          .then(function (data) {
            vm.chatbot = data
            // vm.company.chatbots.push(data);
            vm.chatbotTable.reload()
            NotificationService.successHandler(data, 'Os dados foram criados com sucesso!');
            FoundationApi.publish('addChatbotModal', 'close');
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, 'Erro ao processar requisição, por favor tente novamente.');
          });
      } else {
        ChatbotService
          .update({ id: vm.chatbot.id }, chatbot)
          .$promise
          .then(function (data) {
            vm.chatbot = data
            vm.chatbotTable.reload()
            NotificationService.successHandler(data, 'Os dados foram atualizados com sucesso!');
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, 'Erro ao processar requisição, por favor tente novamente.');
          });
      }
    }

    vm.confirmDelete = function (chatbot) {
      vm.deleting = chatbot
      FoundationApi.publish('confirmDeleteModal', 'open');
    }
  }
})();
